import { useSelector } from 'react-redux';

import { selectUserContext } from '@/entities/layout';
import { useGetProjectDataQuery } from '@/entities/layout';

import { useProjectSiteParams } from '@/shared/lib/hooks';

export const useAboutData = () => {
  const user = useSelector(selectUserContext)?.user;
  const { projectId, siteId } = useProjectSiteParams();

  const { data: projectData, isLoading } = useGetProjectDataQuery(
    {
      projectId,
      siteId
    },
    {
      skip: !projectId || !siteId
    }
  );

  const buildInfo = projectData?.buildInfo;

  return {
    isLoading,
    user,
    buildInfo,
    support: {
      globalEmail: 'rita.global@wfp.org',
      projectEmail: 'rita.global@wfp.org'
    }
  };
};
